import { render } from "./subpartA06.vue?vue&type=template&id=1f12f6d0&scoped=true"
import script from "./subpartA06.vue?vue&type=script&lang=js"
export * from "./subpartA06.vue?vue&type=script&lang=js"

import "./subpartA06.vue?vue&type=style&index=0&id=1f12f6d0&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f12f6d0"]])

export default __exports__